import Chart from "react-apexcharts";
import formatarDuracao from "../../utils/formatarDuracao";

function HeatMapChart({ title, data, suffix, formatter }) {
  const series = data.data;
  const days = data.days;
  const normalizedSuffix = suffix || "";

  const formatMetricValue = (value) => {
    if (formatter === "duration") return formatarDuracao(value);
    const numericValue = Number(value || 0);
    if (normalizedSuffix.includes("%")) {
      return `${numericValue.toLocaleString("pt-BR", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      })}${normalizedSuffix}`;
    }

    return `${numericValue.toLocaleString("pt-BR", {
      maximumFractionDigits: 2,
    })}${normalizedSuffix}`;
  };

  const options = {
    chart: {
      height: 350,
      type: "heatmap",
    },
    dataLabels: {
      enabled: false,
    },
    colors: ["#008FFB"],
    ...(title
      ? {
          title: {
            text: title,
            align: "center",
          },
        }
      : {}),
    yaxis: {
      labels: {
        show: true,
        formatter: function (value) {
          if (!value) return "";
          const match = value.match(/^(\d+)/);
          if (!match) return value;
          return parseInt(match[1]) % 2 === 0 ? value : "";
        },
      },
    },
    xaxis: {
      type: "category",
      categories: days,
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: function (value) {
          return formatMetricValue(value);
        },
      },
    },
  };

  return (
    <Chart options={options} series={series} type="heatmap" height={350} />
  );
}

export default HeatMapChart;
